import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState = true;

export const isFullFooterSlice = createSlice({
  name: 'isFullFooter',
  initialState,
  reducers: {
    activeFullFooter: () => true,
    inactiveFullFooter: () => false,
  },
});

// Action creators are generated for each case reducer function
export const { activeFullFooter, inactiveFullFooter } =
  isFullFooterSlice.actions;

export const getIsFullFooterState = (state: RootState) => state.isFullFooter;

export default isFullFooterSlice.reducer;
